// extracted by mini-css-extract-plugin
export default {"alert":"styles_alert__CzhSJ","message_box":"styles_message_box__RWys1"};